import { render, staticRenderFns } from "./CrowdFundingBody.vue?vue&type=template&id=59932db6&scoped=true&"
import script from "./CrowdFundingBody.vue?vue&type=script&lang=js&"
export * from "./CrowdFundingBody.vue?vue&type=script&lang=js&"
import style0 from "./CrowdFundingBody.vue?vue&type=style&index=0&id=59932db6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59932db6",
  null
  
)

export default component.exports